/**
 * Handles Column sorting of the jobs array based on the selected sort by property.
 * @param {string} sortByValue - The selected sort by property.
 */
function handleSorting(sortDir, sortBy, sortByValue) {
    // Determine the sort direction based on the current state
    const sortDirValue = this.state.sort_dir === 'asc' ? 'desc' : 'asc';
    
    // Sort the jobs array based on the selected sort by property
    this.sortBy(sortByValue);

    // Store the selected sort by property and sort direction in local storage
    localStorage.setItem(sortBy, sortByValue);
    localStorage.setItem(sortDir, this.state.sort_dir === 'asc' ? 'desc' : 'asc');
    
    this.setState({ sort_dir: sortDirValue });
  }
  /**
 * Handles Column sorting of the jobs array based on the selected sort by property.
 * @param {string} sortByValue - The selected sort by property.
 */
  function sortBy(type) {
    let sort_dir = this.state.sort_dir === 'asc' ? 'desc' : 'asc';
    if(type !== this.state.sort_col) {
      const sortDirValue = localStorage.getItem('sortDir');
      sort_dir = sortDirValue;
    }
    let sorted;
    if(sort_dir === 'asc') {
        
      sorted = this.state.filteredJobs.sort(function(a, b) {

        if(type === 'job_type') {
            let a1 = a[type];
            let b1 = b[type];
            let atype = (isNaN(Number(a1)) ? 0 : Number(a1))
            let btype = (isNaN(Number(b1)) ? 0 : Number(b1))
          return (atype ?? 0) > (btype ?? 0) ? 1 : -1  
        }

        return (a[type] ?? "").toLowerCase() > (b[type] ?? "").toLowerCase() ? 1 : -1
      });  
    } else {
        
      sorted = this.state.filteredJobs.sort(function(a, b) {

        if(type === 'job_type') {
            let a1 = a[type];
            let b1= b[type] ;
            let atype = (isNaN(Number(a1)) ? 0 : Number(a1))
            let btype = (isNaN(Number(b1)) ? 0 : Number(b1))
            
          return (atype ?? 0) < (btype ?? 0) ? 1 : -1  
        }

        return (a[type] ?? "").toLowerCase() < (b[type] ?? "").toLowerCase() ? 1 : -1

      });  
    }

    this.setState({
        filteredJobs: sorted,
        sort_col: type,
        sort_dir
    })
  }
  function sortByCrew(type) {
    let sort_dir = this.state.sort_dir === 'asc' ? 'desc' : 'asc';
    if(type !== this.state.sort_col) {
      const sortDirValue = localStorage.getItem('sortDirCrew');
      sort_dir = sortDirValue;
    }
    let sorted;
    if(sort_dir === 'asc') {
        
      sorted = this.state.crew.sort(function(a, b) {

        if(type === 'phone_number') {
            let a1 = (a[type] ?? "").replaceAll("-", "");
            let b1 = (b[type] ?? "").replaceAll("-", "");
            let atype = (isNaN(Number(a1)) ? 0 : Number(a1))
            let btype = (isNaN(Number(b1)) ? 0 : Number(b1))
          return (atype ?? 0) > (btype ?? 0) ? 1 : -1  
        }

        return (a[type] ?? "").toLowerCase() > (b[type] ?? "").toLowerCase() ? 1 : -1
      });  
    } else {
        
      sorted = this.state.crew.sort(function(a, b) {

        if(type === 'phone_number') {
            let a1 = (a[type] ?? "").replaceAll("-", "");
            let b1= (b[type] ?? "").replaceAll("-", "");
            let atype = (isNaN(Number(a1)) ? 0 : Number(a1))
            let btype = (isNaN(Number(b1)) ? 0 : Number(b1))
            
          return (atype ?? 0) < (btype ?? 0) ? 1 : -1  
        }

        return (a[type] ?? "").toLowerCase() < (b[type] ?? "").toLowerCase() ? 1 : -1

      });  
    }

    this.setState({
        crew: sorted,
        sort_col: type,
        sort_dir
    })  
  }
  export { handleSorting, sortBy, sortByCrew };